import axios from 'axios';
import { isAuthenticated, getToken } from './utils/token';

const ForexAPI = axios.create({
  baseURL: process.env.REACT_APP_FOREX_URL,
  headers: {
    Authorization: isAuthenticated()
      ? `Bearer ${getToken().access_token}`
      : null,
  },
});

const AccountAPI = axios.create({
  baseURL: process.env.REACT_APP_ACCOUNT_URL,
  headers: {
    Authorization: isAuthenticated()
      ? `Bearer ${getToken().access_token}`
      : null,
  },
});

export { ForexAPI, AccountAPI };
